/** @format */

import { Chain, KillSwitches } from '@shared/data-access/interfaces';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MyAccountAnalyticsService, Store, UtilityService } from '@shared/data-access/services';

import { Subject, takeUntil } from 'rxjs';

import { AuthenticationService } from '@shared/authentication/data-access';
import { DCSG_CONSTANTS } from '@shared/data-access/constants';

import { take } from 'rxjs/internal/operators/take';

@Component({
	selector: 'my-account-list-templates-signed-out-dashboard',
	templateUrl: './signed-out-dashboard.component.html',
	styleUrl: './signed-out-dashboard.component.scss',
	standalone: false
})
export class SignedOutDashboardComponent implements OnDestroy, OnInit {
	showBtsDashUpdates = false;
	readonly imgUrlPartial = DCSG_CONSTANTS.baseImagePath;

	private readonly ngUnsubscribe: Subject<void> = new Subject();

	constructor(
		private readonly analyticsService: MyAccountAnalyticsService,
		private readonly authenticationService: AuthenticationService,
		private readonly chain: Chain,
		private readonly store: Store,
		private readonly utilityService: UtilityService
	) {}

	ngOnInit(): void {
		this.analyticsService.triggerAnalyticsEvent('NewPageView');
		this.analyticsService.triggerAnalyticsEvent('multiUseAnalyticsEvent', {
			event: 'Signed out athlete clicked Favorites from:',
			value: 'Header'
		});
		this.getKillswitches();
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	// redirect athletes to signin page
	signIn() {
		this.authenticationService
			.login({
				target: this.chain.myAccountUrlAuthListSignIn
			})
			.pipe(take(1))
			.subscribe();
	}

	// redirect athletes to  createAccount page
	createAccount() {
		this.authenticationService.createAccount().pipe(take(1)).subscribe();
	}

	private getKillswitches(): void {
		this.store
			.selectDistinctKey<KillSwitches>('ENVIRONMENT_KILLSWITCH_VALUES')
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe((killswitch) => {
				this.showBtsDashUpdates = this.utilityService.checkKillSwitch(
					'btsDashUpdates',
					killswitch,
					this.chain.chainIdentifierAbbr
				);
			});
	}
}
